import { render, staticRenderFns } from "./DDFileInput.vue?vue&type=template&id=2058d66e&"
import script from "./DDFileInput.vue?vue&type=script&lang=js&"
export * from "./DDFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports